import React, { useState } from 'react'
import injectSheet from 'react-jss'
import { UpsellModal } from '../../pages/prompt/upsell'
import Button from 'pobble-components/dist/button'
import posthog from 'posthog-js'
import classNames from 'classnames'
import { useMe } from 'pobble-components/dist/pobble-user'

export const FreeTrialButton = injectSheet({
  button: {
    marginRight: '16px',
    marginLeft: 'auto'
  },
  buttonAccent: {
    color: '#fff !important',
    border: '1px solid #fff !important',
    '& > div': {
      textShadow: '0px 0px 1px #000'
    },
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.1) !important'
    }
  }
})(function FreeTrialButton({ classes }) {
  const [upsellModalOpen, setUpsellModalOpen] = useState(false)
  const { me } = useMe()
  const isSchoolRepresentative =
    me.account.role_in_life === 'school_administrator' ||
    me.account.role_in_life === 'english_leader_in_school'

  return (
    <>
      <Button
        icon={'🔓'}
        onClick={() => {
          posthog.capture('clicked on header free trial button')
          setUpsellModalOpen(true)
        }}
        className={classNames(classes.button, classes.buttonAccent)}>
        {!isSchoolRepresentative && 'Try premium features'}
        {isSchoolRepresentative && 'Pobble for schools'}
      </Button>
      <UpsellModal
        id="header"
        isOpen={upsellModalOpen}
        requestClose={() => setUpsellModalOpen(false)}
      />
    </>
  )
})
